import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddTestingDidRequest, DidProvider, DID_CLASS, DID_STATUS, DID_TYPE, DID } from 'voxloud-types/dist/models/dids/dids.model';
import { DidsService } from 'src/app/domains/dids/services';
import { AddTestingDidManuallyRequest } from 'src/app/domains/dids/models';

@Component({
  selector: 'gdp-add-testing-did-popup',
  templateUrl: './add-testing-did-popup.component.html',
  styleUrls: ['./add-testing-did-popup.component.scss']
})
export class AddTestingDidPopupComponent implements OnInit {
  public companyId: number;
  public form: UntypedFormGroup;
  public countryCode: string = 'it';
  public availableClasses = Object.keys(DID_CLASS);
  public availableTypes = Object.keys(DID_TYPE);
  public availableProviders: string[] = [];
  public loading = {
    get: false,
    submit: false
  };
  public planAddonHandling: string;
  @Output() onAddTestingDid: EventEmitter<string> = new EventEmitter();

  constructor(
    private activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private didsService: DidsService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      phone: new UntypedFormControl(null, [Validators.required]),
      class: new UntypedFormControl(this.availableClasses[1], [Validators.required]),
      type: new UntypedFormControl(this.availableTypes[0], [Validators.required]),
      provider: new UntypedFormControl(null, [Validators.required]),
      providerReference: new UntypedFormControl(null)
    });
    this.getProviders();
  }

  public isFieldInvalid(name: string): boolean {
    let control = this.form.controls[name];
    return control.touched && control.invalid;
  }

  public onChangeState(event): void {
    this.countryCode = event.iso2;
  }

  public selectDidClass(value: string): void {
    this.form.patchValue({ class: value });
  }

  public selectDidType(value: string): void {
    this.form.patchValue({ type: value });
  }

  public selectProvider(value: string): void {
    this.form.patchValue({ provider: value });
  }

  public onSubmit(): void {
    const controls = this.form.controls;
    const payload: AddTestingDidRequest | AddTestingDidManuallyRequest = this.buildPayload(controls);
    this.loading.submit = true;
    if(this.planAddonHandling === 'manual') {
      this.addTestingDidManually(<AddTestingDidManuallyRequest>payload);
    } else {
      this.addTestingDid(<AddTestingDidRequest>payload);
    }
  }

  private getProviders(): void {
    this.loading.get = true;
    this.didsService.getProviders().subscribe((res: DidProvider[]) => {
      this.availableProviders = res.map(provider => provider.name);
      this.loading.get = false;
      this.form.get('provider').setValue(this.availableProviders[0]);
    }, () => {
      this.loading.get = false;
    });
  }

  private buildPayload(controls: any): AddTestingDidRequest | AddTestingDidManuallyRequest {
    let payload: any = {
      number: controls.phone.value,
      provider: controls.provider.value,
      class: controls.class.value,
      type: controls.type.value,
      status: DID_STATUS.UNDER_TESTING,
      provider_reference: controls.providerReference.value
    };
    if(this.planAddonHandling === 'manual') {
      payload = {
        ...payload,
        company_id: this.companyId
      };
    } else {
      payload = {
        ...payload,
        country_code: this.countryCode,
      };
    }
    return payload;
  }

  private addTestingDid(payload: AddTestingDidRequest): void {
    this.didsService.addTestingDid(this.companyId, payload).subscribe((res: string) => {
      this.onAddTestingDid.emit(res);
      this.loading.submit = false;
      this.close();
    }, () => {
      this.loading.submit = false;
      this.close();
    });
  }

  private addTestingDidManually(payload: AddTestingDidManuallyRequest): void {
    this.didsService.addDidManually(payload).subscribe((res: DID) => {
      this.onAddTestingDid.emit(res.number);
      this.loading.submit = false;
      this.close();
    }, () => {
      this.loading.submit = false;
      this.close();
    });
  }

  public close() {
    this.activeModal.close();
  }
}
